import React, { FC, useContext } from 'react'

import { Photo, Photos } from 'components/page/ForeignProfile/common.types'
import { ForeignPhotoContext } from 'components/page/ForeignProfile/ForeignProfile.constants'
import { skipEndPointIncognito } from 'components/page/ForeignProfile/Photos/function/skipEndPointIncogito'
import {
  Image,
  WrapperMobile,
  WrapperMobileLast,
} from 'components/page/ForeignProfile/Photos/MobilePhotos/MobilePhotos.styles'
import { RouterLink } from 'components/presentational/link'

import { PhotosTileLastBlock } from '../PhotosTile/PhotoTileLastBlock/PhotosTileLastBlock'

/**
 * @param photo
 * @param photos
 * @returns
 * Либо приходит photo, либо приходит photos.
 * photo отображение в анкете первая, и между блоков
 * photos, отображение под максой самым последним фото.
 */
export const MobilePhotosView: FC<{
  photo?: Photo
  photos?: Photos
}> = ({ photo, photos }) => {
  const { baseHrefPhoto, useAuthorizationUrl } = useContext(ForeignPhotoContext)

  if (photo) {
    const url = skipEndPointIncognito(
      baseHrefPhoto,
      photo.photoId,
      useAuthorizationUrl
    )

    return (
      <WrapperMobile>
        <RouterLink to={url}>
          <Image
            src={photo.urls.square}
            data-name={`photoviewer-${photo.photoId}-photo`}
          />
        </RouterLink>
      </WrapperMobile>
    )
  }

  if (photos!.length > 0) {
    return (
      <WrapperMobileLast>
        <PhotosTileLastBlock restPhotos={photos!} />
      </WrapperMobileLast>
    )
  }

  return null
}
